import type React from 'react';
import dayjs from 'dayjs';
import { useDocumentExpiryDate } from '../../../../hooks/useDocumentExpiryDate';
import { useExpiryDateCalendar } from '../ShareV3/useExpiryDateCalendar';
import { useDocumentExpirationLabel } from '../../../preview/banner/useDocumentExpirationLabel';
import ExpiryBanner from '../../../ExpiryBanner/ExpiryBanner';
import { useContentMetadata } from 'components/editor/hooks/useContentMetadata';
import { ContentType } from 'utils/getContentType';

interface EditorBannerProps {
  contentId: string;
}

const EditorBanner: React.FC<EditorBannerProps> = ({ contentId }) => {
  const { data: documentData } = useContentMetadata(ContentType.DOCUMENT, contentId);
  const { getDocumentExpiryDate, isDocumentExpired } = useDocumentExpiryDate({ contentId });
  const currentExpiryAtDate = dayjs(getDocumentExpiryDate.data?.expire_at ?? null);
  const { open: openCalendar, modal } = useExpiryDateCalendar({ contentId, currentExpiryAtDate });
  const { hasExpirationDate, formattedDate } = useDocumentExpirationLabel({ expiryDate: currentExpiryAtDate });

  const isOwner = documentData?.isDocumentBelongsToSameAccount ?? false;
  const isExpired = isDocumentExpired().isExpired === true;

  return (
    <ExpiryBanner
      isExpired={isExpired}
      isOwner={isOwner}
      hasExpirationDate={hasExpirationDate}
      formattedDate={formattedDate}
      openCalendar={openCalendar}
      modal={modal}
    />
  );
};

export default EditorBanner;
